"use client";
import { FilterList, ResultsData } from "../../../app/bus/results/types";

import { FunctionComponent, ReactNode, useReducer } from "react";
import {
  GovtBuses,
  NoResultsFound,
  ResultsStore,
  SelectedFilters,
  Types,
} from "./types";

import { ResultsContext } from "./context";
import { initialState } from "./store";
import { reducer } from "./reducer";
import {
  Action,
  applyFilters,
  clearContextData,
  setFilterList,
  setGovtBuses,
  setListOptions,
  setNoResultsFound,
  setResultsLoading,
  setSelectedFilters,
  setShowSeatLayout,
  setshowFilters,
} from "./action";

interface Props {
  children: ReactNode;
}

const ResultsProvider: FunctionComponent<Props> = (props) => {
  const [state, dispatch] = useReducer<React.Reducer<ResultsStore, Action>>(
    reducer,
    initialState
  );

  const value = {
    resultsData: state.resultsData,
    filterResults: state.filterResults,
    sortBy: state.sortBy,
    departure: state.departure,
    busType: state.busType,
    starRating: state.starRating,
    selectedFilters: state.selectedFilters,
    amenities: state.amenities,
    pickupPoints: state.pickupPoints,
    dropOffPoints: state.dropOffPoints,
    busOperators: state.busOperators,
    showFilters: state.showFilters,
    noResultsFound: state.noResultsFound,
    filterList: state.filterList,
    govtBuses: state.govtBuses,
    filteredGovtBuses: state.filteredGovtBuses,
    resultsLoading: state.resultsLoading,
    showSeatLayout: state.showSeatLayout,
    setResultsData: (resultsData: ResultsData) => {
      dispatch({ type: Types.SET_RESULTS_DATA, payload: resultsData });
    },

    setListOptions: (item: {
      amenities: FilterList[];
      pickupPoints: FilterList[];
      dropOffPoints: FilterList[];
      busOperators: FilterList[];
    }) => {
      dispatch(setListOptions(item));
    },

    applyFilters: (
      newFilterResults: ResultsData,
      newFilteredGovtBuses: GovtBuses,
      newFilterList: Record<string, FilterList[]>
    ) => {
      dispatch(
        applyFilters({ newFilterResults, newFilteredGovtBuses, newFilterList })
      );
    },
    setShowFilters: () => {
      dispatch(setshowFilters(null));
    },
    setNoResultsFound: (item: NoResultsFound) => {
      dispatch(setNoResultsFound(item));
    },
    setFilterList: (item: Record<string, any>) => {
      dispatch(setFilterList(item));
    },
    setGovtBuses: (item: GovtBuses) => {
      dispatch(setGovtBuses(item));
    },
    setSelectedFilters: (item: SelectedFilters) => {
      dispatch(setSelectedFilters(item));
    },
    setResultsLoading: (item: boolean) => {
      dispatch(setResultsLoading(item));
    },
    clearContextData: () => {
      dispatch(clearContextData(null));
    },
    setShowSeatLayout: (item: boolean) => {
      dispatch(setShowSeatLayout(item));
    },
  };

  return (
    <ResultsContext.Provider value={value}>
      {props.children}
    </ResultsContext.Provider>
  );
};

export default ResultsProvider;
